import React, { useState, useEffect } from 'react';
import Flag from 'react-world-flags';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

const dstPeriods = {
  US: { start: '2024-03-10', end: '2024-11-03' },
  EU: { start: '2024-03-31', end: '2024-10-27' },
  AU: { start: '2024-10-06', end: '2025-04-06' },
  NZ: { start: '2024-09-29', end: '2025-04-06' },
};

dayjs.extend(utc);
dayjs.extend(timezone);

// Static JSON Data embedded
const staticCalendarData = [
  {
    "country": "日本",
    "date": "2024-10-30",
    "indicator_abbreviation": "BOJ MPM",
    "TV": "ECONOMICS:JPINTR",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-10-31",
    "indicator_abbreviation": "BOJ MPM",
    "TV": "ECONOMICS:JPINTR",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-10-31",
    "indicator_abbreviation": "BOJ",
    "indicator_name_en": "BOJ Minutes",
    "indicator_name_jp": "総裁定例記者会見",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:30",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-12-19",
    "indicator_abbreviation": "BOJ",
    "indicator_name_en": "BOJ Minutes",
    "indicator_name_jp": "総裁定例記者会見",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:30",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-12-18",
    "indicator_abbreviation": "BOJ MPM",
    "TV": "ECONOMICS:JPINTR",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-12-19",
    "indicator_abbreviation": "BOJ MPM",
    "TV": "ECONOMICS:JPINTR",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/mopo/mpmsche_minu/index.htm",
    "value": ""
  },
  {
    "country": "日本",
    "date": "2024-09-20",
    "indicator_abbreviation": "BOJ MPM",
    "TV": "ECONOMICS:JPINTR",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmdeci/mpr_2024/k240920a.pdf",
    "url_jp": "https://www.boj.or.jp/mopo/mpmdeci/mpr_2024/k240920a.pdf",
    "value": "0.25"
  },
  {
    "country": "日本",
    "date": "2024-09-19",
    "TV": "ECONOMICS:JPINTR",
    "indicator_abbreviation": "BOJ MPM",
    "indicator_name_en": "BOJ interest rate decision",
    "indicator_name_jp": "金融政策決定会合",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmdeci/mpr_2024/k240920a.pdf",
    "url_jp": "https://www.boj.or.jp/mopo/mpmdeci/mpr_2024/k240920a.pdf",
    "value": "0.25"
  },
  {
    "country": "日本",
    "date": "2024-09-20",
    "indicator_abbreviation": "BOJ Minutes",
    "indicator_name_en": "BOJ Minutes",
    "indicator_name_jp": "総裁定例記者会見",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "15:30",
    "timezone": "JST",
    "url_en": "https://www.boj.or.jp/en/mopo/mpmsche_minu/index.htm",
    "url_jp": "https://www.boj.or.jp/about/press/kaiken_2024/kk240924a.pdf",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-09-18",
    "TV": "ECONOMICS:FEDFUNDS",
    "indicator_abbreviation": "FOMC FFR",
    "indicator_name_jp": "FOMC 政策金利",
    "indicator_name_en": "FOMC Meeting",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "url_jp": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "value": "5.0"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-09-18",
    "indicator_abbreviation": "FRB Minutes",
    "indicator_name_jp": "FRB 議長定例記者会見",
    "indicator_name_en": "FRB Mniutes",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:30",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "url_jp": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-09",
    "indicator_abbreviation": "FOMC Minutes",
    "indicator_name_jp": "FOMC 定例記者会見",
    "indicator_name_en": "FOMC Mniutes",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "url_jp": "https://www.federalreserve.gov/newsevents/pressreleases/monetary20240918a.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-11-07",
    "indicator_abbreviation": "FOMC Meeting",
    "indicator_name_jp": "FOMC 政策金利決定会議",
    "indicator_name_en": "FOMC Meeting",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "url_jp": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-11-26",
    "indicator_abbreviation": "FOMC Minutes",
    "indicator_name_jp": "FOMC 定例記者会見",
    "indicator_name_en": "FOMC Mniutes",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "url_jp": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-12-18",
    "indicator_abbreviation": "FOMC Meeting",
    "indicator_name_jp": "FOMC 政策金利決定会議",
    "indicator_name_en": "FOMC Meeting",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "14:00",
    "timezone": "EDT",
    "url_en": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "url_jp": "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-11-01",
    "indicator_abbreviation": "Employment Situation",
    "indicator_name_jp": "雇用統計",
    "indicator_name_en": "Employment Situation",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "08:30",
    "timezone": "EDT",
    "url_en": "https://www.bls.gov/schedule/2024/11_sched.htm",
    "url_jp": "https://www.bls.gov/schedule/2024/11_sched.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-04",
    "indicator_abbreviation": "Employment Situation",
    "indicator_name_jp": "雇用統計",
    "indicator_name_en": "Employment Situation",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "08:30",
    "timezone": "EDT",
    "url_en": "https://www.bls.gov/schedule/2024/10_sched.htm",
    "url_jp": "https://www.bls.gov/schedule/2024/10_sched.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-12-06",
    "indicator_abbreviation": "Employment Situation",
    "indicator_name_jp": "雇用統計",
    "indicator_name_en": "Employment Situation",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "08:30",
    "timezone": "EDT",
    "url_en": "https://www.bls.gov/schedule/2024/11_sched.htm",
    "url_jp": "https://www.bls.gov/schedule/2024/11_sched.htm",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-24",
    "indicator_abbreviation": "",
    "indicator_name_jp": "新築住宅販売件数",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "23:00",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": "738000"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-17",
    "indicator_abbreviation": "",
    "indicator_name_jp": "小売売上高",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": "0.4"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-10",
    "indicator_abbreviation": "",
    "indicator_name_jp": "消費者物価指数(CPIコア)",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": "0.3"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-10",
    "indicator_abbreviation": "",
    "indicator_name_jp": "消費者物価指数(CPI前月比)",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": "0.2"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-11",
    "indicator_abbreviation": "",
    "indicator_name_jp": "ISM製造業景況指数",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "23:00",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": "47.2"
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-31",
    "indicator_abbreviation": "",
    "indicator_name_jp": "PCE",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-31",
    "indicator_abbreviation": "",
    "indicator_name_jp": "PCEコアデフレーター",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": ""
  },
  {
    "country": "アメリカ合衆国",
    "date": "2024-10-31",
    "indicator_abbreviation": "",
    "indicator_name_jp": "PCEデフレーター",
    "indicator_name_en": "",
    "remarks_en": "",
    "remarks_jp": "",
    "time": "21:30",
    "timezone": "JST",
    "url_en": "",
    "url_jp": "",
    "value": ""
  }
  // ... add the remaining data entries here
];

// 背景色をブラウザ全体に適用するために追加
const styles = (borderWidth, isMobile) => `
  body {
    background-color: #f0f8ff; /* 例: アリスブルー */
  }

  .calendar-cell {
    width: ${isMobile ? '12ch' : '20ch'};
    max-width: ${isMobile ? '12ch' : '20ch'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${borderWidth !== 'none' ? `border: ${borderWidth}px solid gray;` : ''}
  }

  .popup {
    position: absolute;
    z-index: 10;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    pointer-events: none;
    font-size: ${isMobile ? '10px' : '12px'};
  }

  .calendar-events {
    max-height: ${isMobile ? '50px' : '60px'};
    overflow-y: auto;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const translations = {
  en: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    previous: '<',
    next: '>',
    close: 'Close',
    languageToggle: 'Japanese',
    flagToggle: 'Flags',
    timezoneToggle: 'Timezone',
    events: '(x events)',
    currentMonthButton: 'Current Month',
    displayOptions: {
      url: 'url',
      indicator_name: 'indicator',
      value: 'Value',
      remarks: 'Remarks',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      hour: 'Hour',
      minute: 'Minute',
      country: 'Country',
      flagOrCode: '(Flag/Code)',
      line: 'Line',
      lineThickness: 'Line Thickness'
    },
    flagToggleButton: 'Flags'
  },
  ja: {
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    days: ['日', '月', '火', '水', '木', '金', '土'],
    previous: '<',
    next: '>',
    close: '閉じる',
    languageToggle: 'English',
    flagToggle: '国旗',
    timezoneToggle: 'タイムゾーン',
    events: '(x件)',
    currentMonthButton: '当月へ',
    displayOptions: {
      url: '参照',
      indicator_name: '指標',
      value: '値',
      remarks: '備考',
      year: '年',
      month: '月',
      day: '日',
      hour: '時',
      minute: '分',
      country: '国',
      flagOrCode: '(国旗/コード)',
      line: '線',
      lineThickness: '線の太さ'
    },
    flagToggleButton: '国旗'
  }
};

const countryCodes = {
  '日本': 'JP',
  'アメリカ合衆国': 'US',
  'ユーロ圏': 'EU',
};

const timezones = {
  JST: 'Asia/Tokyo',
  EDT: 'America/New_York',
  GMT: 'Europe/London',
};

const FinancialCalendar = () => {
  const [calendarData, setCalendarData] = useState(staticCalendarData.length > 0 ? staticCalendarData : []);
  const [loading, setLoading] = useState(staticCalendarData.length === 0); // データがある場合は false

  const [currentMonth, setCurrentMonth] = useState(9); // 10月は0-basedで9
  const [currentYear, setCurrentYear] = useState(2024);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [language, setLanguage] = useState('ja');
  const [showFlags, setShowFlags] = useState(true);
  const [timezone, setTimezone] = useState('JST'); // 基準タイムゾーンの状態
  const [popupContent, setPopupContent] = useState(null); // ポップアップのコンテンツ
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 }); // ポップアップの位置
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600); // スマートフォンかどうか

  const title = language === 'ja' ? 'マーケットカレンダー β' : 'Market Calendar β';

  // 画面サイズの変更を監視してスマートフォンかどうかを切り替える
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    
  }, []);

  // 表示オプションの状態管理
  const [showYear, setShowYear] = useState(false);
  const [showMonth, setShowMonth] = useState(false);
  const [showDay, setShowDay] = useState(false);
  const [showHour, setShowHour] = useState(true);
  const [showMinute, setShowMinute] = useState(true);
  const [showCountry, setShowCountry] = useState(true);
  const [borderWidth, setBorderWidth] = useState('1'); // 線の太さ

  // 当月に戻る関数
  const goToCurrentMonth = () => {
    const today = new Date();
    setCurrentMonth(today.getMonth()); // 現在の月を設定（0-basedであることに注意）
    setCurrentYear(today.getFullYear()); // 現在の年を設定
  };

  // JSONファイルからデータを読み込む
  useEffect(() => {
    if (staticCalendarData.length === 0) {
      const fetchCalendarData = async () => {
        try {
          const response = await fetch('/calendarData.json');
          if (!response.ok) {
            throw new Error('データの取得に失敗しました');
          }
          const data = await response.json();
          setCalendarData(data);
        } catch (error) {
          console.error('データの読み込みに失敗しました', error);
        } finally {
          setLoading(false);
        }
      };
      fetchCalendarData();
    } else {
      setLoading(false); // staticCalendarDataが存在する場合はloadingをfalseに
    }
  }, []);

  // 基準タイムゾーンに基づく時刻と日付の変換
  const convertToTimezone = (date, time, eventTimezone) => {
    const dateTime = `${date}T${time}`;
    let eventTime = dayjs.tz(dateTime, timezones[eventTimezone]);
  
    // Determine if DST applies based on the event's timezone and date
    const eventDate = dayjs(date);
    const dstRange = dstPeriods[eventTimezone];
  
    if (dstRange) {
      const isDst = eventDate.isAfter(dstRange.start) && eventDate.isBefore(dstRange.end);
  
      if (isDst) {
        // Adjust for DST by adding an hour for relevant regions
        eventTime = eventTime.add(1, 'hour');
      }
    }
  
    return eventTime.tz(timezones[timezone]);
  };
  
  // タイムゾーンに合わせて指標をフィルタリングし、時刻順に並べ替える
  const filteredCalendarData = staticCalendarData
    .map(event => {
      const convertedTime = convertToTimezone(event.date, event.time, event.timezone);
      return {
        ...event,
        convertedDate: convertedTime.format('YYYY-MM-DD'),
        convertedTime: convertedTime.format('HH:mm')
      };
    })
    .filter(event => {
      const eventDate = new Date(event.convertedDate);
      return eventDate.getFullYear() === currentYear && eventDate.getMonth() === currentMonth;
    })
    .sort((a, b) => {
      const timeA = `${a.convertedDate}T${a.convertedTime}`;
      const timeB = `${b.convertedDate}T${b.convertedTime}`;
      return new Date(timeA) - new Date(timeB);
    });

  const handleMonthChange = (increment) => {
    let newMonth = currentMonth + increment;
    let newYear = currentYear;

    if (newMonth > 11) {
      newMonth = 0;
      newYear++;
    } else if (newMonth < 0) {
      newMonth = 11;
      newYear--;
    }

    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };

  // 指標をクリックしたときにURLを開く
  const handleIndicatorClick = (indicator) => {
    const url = language === 'en' ? indicator.url_en : indicator.url_jp;
    if (url && typeof url === 'string' && url.trim() !== '') {
      window.open(url, '_blank');
    }
  };

  const toggleLanguage = () => {
    setLanguage(prevLang => (prevLang === 'en' ? 'ja' : 'en'));
  };

  const toggleFlagDisplay = () => {
    setShowFlags(prevShowFlags => !prevShowFlags);
  };

  const handleTimezoneChange = (e) => {
    setTimezone(e.target.value);
  };

  // マウスオーバー時にポップアップを表示
  const handleMouseEnter = (event, data) => {
    const t = translations[language];
    const remarks = language === 'en' ? data.remarks_en : data.remarks_jp;
    const indicator_name = language === 'en' ? data.indicator_name_en : data.indicator_name_jp;
    const value = data.value;
    const url = language === 'en' ? data.url_en : data.url_jp;
  
    let content = (
      <>
        <p><strong>{t.displayOptions.indicator_name}:</strong> {indicator_name}</p>
        {value && <p><strong>{t.displayOptions.value}:</strong> {value}</p>}
        {remarks && <p><strong>{t.displayOptions.remarks}:</strong> {remarks}</p>}
        {url && url.trim() !== '' && (
          <p>
            <strong>{t.displayOptions.url}:</strong> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
          </p>
        )}
      </>
    );
  
    setPopupContent(content);
    setPopupPosition({ 
      x: Math.min(event.clientX + 15, window.innerWidth - 150), 
      y: Math.min(event.clientY + 15, window.innerHeight - 100) 
    });
  };

  // マウスが離れたときにポップアップを非表示
  const handleMouseLeave = () => {
    setPopupContent(null);
  };

  const renderCalendar = () => {
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const weeks = [];
    let days = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<td key={`empty-${i}`} className="calendar-cell"></td>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const eventsForDay = filteredCalendarData.filter(event => new Date(event.convertedDate).getDate() === day);
      const isToday = day === new Date().getDate() && currentMonth === new Date().getMonth() && currentYear === new Date().getFullYear();
      const dayColor = (firstDayOfMonth + day - 1) % 7 === 0 ? 'text-red-500' : ((firstDayOfMonth + day - 1) % 7 === 6 ? 'text-blue-500' : '');

      days.push(
        <td key={day} className={`calendar-cell p-1 align-top ${isToday ? 'bg-yellow-100' : ''}`} style={{ height: '100px' }}>
          <div className="calendar-cell-content">
            <div className={`calendar-date font-bold text-center ${dayColor}`}>
              {day} {language === 'en' ? `(${eventsForDay.length} events)` : `(${eventsForDay.length}件)`}
            </div>
            <div className="calendar-events text-left">
              {eventsForDay.map((event, index) => (
                <div
                  key={index}
                  className="text-xs text-gray-500 cursor-pointer hover:underline truncate"
                  onMouseEnter={(e) => handleMouseEnter(e, event)}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => handleIndicatorClick(event)}
                >
                  <span className="mr-2">
                    {showYear && `${event.convertedDate.split('-')[0]} `}
                    {showMonth && `${event.convertedDate.split('-')[1]} `}
                    {showDay && `${event.convertedDate.split('-')[2]} `}
                    {showHour && `${event.convertedTime.split(':')[0]}:`}
                    {showMinute && `${event.convertedTime.split(':')[1]} `}
                  </span>
                  {showCountry && (showFlags ? (
                    <Flag code={countryCodes[event.country]} className="mr-1" style={{ width: '20px', display: 'inline-block' }} />
                  ) : (
                    <span className="mr-1">{countryCodes[event.country]}</span>
                  ))}
                  {language === 'en' ? event.indicator_name_en : event.indicator_name_jp}
                </div>
              ))}
            </div>
          </div>
        </td>
      );

      if (days.length === 7) {
        weeks.push(<tr key={day}>{days}</tr>);
        days = [];
      }
    }

    if (days.length > 0) {
      weeks.push(<tr key={daysInMonth}>{days}</tr>);
    }

    return weeks;
  };

  const t = translations[language];

  const renderYearMonth = () => {
    if (language === 'ja') {
      return `${currentYear}年 ${currentMonth + 1}月`;
    } else {
      return `${t.months[currentMonth]} ${currentYear}`;
    }
  };

  return (
      <div className="container mx-auto p-4 font-sans">
          {/* Add the title block here */}
          <div className="flex justify-center mb-4">
        <h1 className="text-3xl font-bold">
          {language === 'ja' ? 'マーケットカレンダー β' : 'Market Calendar β'}
        </h1>
      </div>
      <style>{styles(borderWidth, isMobile)}</style>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          <button onClick={() => handleMonthChange(-1)} className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600">{t.previous}</button>
          <h2 className="text-2xl font-bold mx-4">{renderYearMonth()}</h2>
          <button onClick={goToCurrentMonth} className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600">{t.currentMonthButton}</button>
          <button onClick={() => handleMonthChange(1)} className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600">{t.next}</button>
        </div>

        <div>
          <select id="timezone" value={timezone} onChange={handleTimezoneChange} className="px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md">
            <option value="JST">JST (Tokyo)</option>
            <option value="EDT">EDT (New York)</option>
            <option value="GMT">GMT (London)</option>
          </select>
        </div>
        <div className="flex flex-wrap space-x-4">
          <div>
            <label className="mr-2">
              <select value={borderWidth} onChange={(e) => setBorderWidth(e.target.value)}>
                <option value="none">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select> {t.displayOptions.lineThickness}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showYear} onChange={() => setShowYear(!showYear)} /> {t.displayOptions.year}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showMonth} onChange={() => setShowMonth(!showMonth)} /> {t.displayOptions.month}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showDay} onChange={() => setShowDay(!showDay)} /> {t.displayOptions.day}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showHour} onChange={() => setShowHour(!showHour)} /> {t.displayOptions.hour}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showMinute} onChange={() => setShowMinute(!showMinute)} /> {t.displayOptions.minute}
            </label>
            <label className="mr-2">
              <input type="checkbox" checked={showCountry} onChange={() => setShowCountry(!showCountry)} /> {t.displayOptions.country}
            </label>
            <button onClick={toggleFlagDisplay} className="px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md">{t.flagToggleButton}</button>
          </div>
          <button onClick={toggleLanguage} className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600">{t.languageToggle}</button>
        </div>
      </div>

      {loading ? (
        <p>データを読み込み中...</p>
      ) : (
        <>
          <table className={`w-full text-sm border-collapse`}>
            <thead>
              <tr className={`${borderWidth !== 'none' ? `border-b border-gray-200` : ''}`}>
                {t.days.map((day, index) => (
                  <th key={day} className={`calendar-cell p-1 align-top ${index === 0 ? 'text-red-500' : index === 6 ? 'text-blue-500' : ''}`} style={{ whiteSpace: 'nowrap', height: 'auto' }}>
                    {day}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {renderCalendar()}
            </tbody>
          </table>
          {popupContent && (
            <div className="popup" style={{ top: popupPosition.y, left: popupPosition.x }}>
              {popupContent}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FinancialCalendar;
